import type { ReactNode } from "react";
import type { intlFormatPropTypes } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import type { HostHubUpcomingBooking } from "../../types/model/upcoming-booking";
import HostHubUpcomingPanelBookingItem from "./HostHubUpcomingPanelBookingItem";

type HostHubUpcomingPanelBookingGroupProps = {
  bookings: HostHubUpcomingBooking[];
  intl: intlFormatPropTypes;
  label: ReactNode;
};

const HostHubUpcomingPanelBookingGroup = ({
  bookings,
  intl,
  label,
}: HostHubUpcomingPanelBookingGroupProps) => (
  <div className="tw-flex tw-flex-col tw-gap-[8px]">
    <Text className="tw-my-0 tw-text-gray-600" typeface="body-1">
      {label}
    </Text>
    {bookings.map((booking) => (
      <HostHubUpcomingPanelBookingItem
        booking={booking}
        intl={intl}
        key={`${booking.primaryCtaRoute}-${booking.startDate}`}
      />
    ))}
  </div>
);

export default HostHubUpcomingPanelBookingGroup;
